import TwoColumnLayOut from "../../layouts/two-columns/two-column-layout";
import WhoWeAreComponent from "./components/index.component";

const WhoWeAre = () => {
  const breadcrumbPath = "Who-We-Are";

  return (
    <>
      <TwoColumnLayOut breadcrumbPath={breadcrumbPath} isBreadcrumbpath={true} showAds={true}>
        <WhoWeAreComponent />
      </TwoColumnLayOut>
    </>
  );
};

export default WhoWeAre;
